// Shared status taxonomy + band mapping for project/workflow status.
// Pulled out of Dashboard.tsx so the executive dashboard (and any future
// surface) reuses one source of truth instead of re-deriving the same map.

export const WORKFLOW_STATUSES = [
  "Submitted",
  "Had Scoping Call",
  "Initial Intake Conversation Complete",
  "Evaluation Template Complete",
  "AI Advisory Board Approved",
  "AI Steer Co Approved",
  "In Progress",
  "Completed",
  "Completed, Story Told",
] as const;

export const ON_HOLD_STATUSES = [
  "On Hold (High-Risk Data)",
  "On Hold (Other)",
] as const;

export const REJECTED_STATUSES = [
  "Rejected (Not Accelerator Project)",
  "Rejected (Other)",
] as const;

export type Band = "active" | "shipped" | "paused" | "rejected";

export function bandFor(status: string): Band {
  if (status.startsWith("Rejected")) return "rejected";
  if (status.startsWith("On Hold")) return "paused";
  if (status === "Completed" || status === "Completed, Story Told") return "shipped";
  return "active";
}

// DIT-approved color tokens. "active" uses primary navy so the dominant
// pipeline segment reads as the brand spine.
export const BAND_COLOR: Record<Band, string> = {
  active: "#092940",
  shipped: "#1F6B3A",
  paused: "#C58A00",
  rejected: "#CF1F42",
};

export const BAND_DOT_CLASS: Record<Band, string> = {
  active: "apex-dot--primary",
  shipped: "apex-dot--green",
  paused: "apex-dot--yellow",
  rejected: "apex-dot--red",
};

export const BAND_LABEL: Record<Band, string> = {
  active: "Active",
  shipped: "Delivered",
  paused: "On hold",
  rejected: "Rejected",
};
